import { Box } from "@mui/material";
import React from "react";
import SocialMedia from "./SocialMedia";

const Footer = (propse) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          display: propse.Width < 560 ? "none" : "flex",
          width: "100%",
          height: "80px",
          fontFamily: "Outfit",
          fontSize: "0.7rem",
          color: "rgba(0,0,0,0.6)",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "50%",
            marginTop: "15px",
            marginLeft:
              propse.Width >= 560 && propse.Width < 768 ? "20px" : "50px",
          }}
        >
          <span>Copyright © December-2021. All rights Reserved.</span>
          <span>Created by Ramin Maghsoodi</span>
          <SocialMedia />
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Footer;
